import { dedupeRepositoryContextSources } from '@/components/projects/workflows/shared/contextSourceDedup'
import type { ContextSourceListItem, TriggerInputField } from '@/types'

export type FormValues = Record<string, string>

export const FIELD_LABEL_CLASS = 'text-xs font-bold leading-[1.6] tracking-[0.015em] text-card-foreground'
export const FIELD_INPUT_CLASS = 'h-10 rounded-lg px-3 py-2 border-border bg-input-background'
export const FIELD_HINT_CLASS = 'text-xs font-normal leading-[1.6] tracking-[0.015em] text-card-foreground'

export function buildDefaults(fields: TriggerInputField[], contextItems: ContextSourceListItem[] = []): FormValues {
  const defaults: FormValues = {}
  for (const field of fields) {
    if (field.type === 'boolean') {
      defaults[field.name] = field.default ?? 'false'
    } else if (field.type === 'context-picker' && field.multiSelect && contextItems.length > 0) {
      const filtered = field.contextType
        ? contextItems.filter(s => s.kind.toLowerCase() === field.contextType!.toLowerCase())
        : contextItems

      const deduped = dedupeRepositoryContextSources(filtered)

      defaults[field.name] = deduped.length > 0 ? JSON.stringify(deduped.map(s => s.id)) : (field.default ?? '')
    } else {
      defaults[field.name] = field.default ?? ''
    }
  }
  return defaults
}

export function describedBy(field: TriggerInputField, error: unknown): string | undefined {
  if (error) return `trigger-${field.name}-error`
  return field.description ? `trigger-${field.name}-hint` : undefined
}

export function formatLabel(name: string): string {
  return name
    .replace(/([A-Z])/g, ' $1')
    .replace(/[_-]/g, ' ')
    .replace(/^\w/, (c) => c.toUpperCase())
    .trim()
}
